export enum ServiceStartType {
  Immediate = "immediate",
  Deferred = "deferred",
}
